'use strict';

var dateFns = require('date-fns');

const areMultipleTimestampIntervalsOverlapping = (intervals, options) => {
  for (let i = 0; i < intervals.length; i++) {
    for (let j = i + 1; j < intervals.length; j++) {
      const intervalsI = intervals[i];
      const intervalsJ = intervals[j];
      if (intervalsI === void 0 || intervalsJ === void 0) {
        console.warn(
          "[packages/date] intervalsI === undefined || intervalsJ === undefined \uC778 \uC0C1\uD669\uC774 \uC758\uB3C4\uC778\uC9C0 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
        );
      }
      if (dateFns.areIntervalsOverlapping(intervalsI, intervalsJ, options)) {
        return true;
      }
    }
  }
  return false;
};

module.exports = areMultipleTimestampIntervalsOverlapping;
//# sourceMappingURL=areMultipleTimestampIntervalsOverlapping.cjs.map
